import { useSelector } from "react-redux";

import { useAlgoliaActions } from "store/AlgoliaSlice";

const useAlgolia = () => {
  const {
    addOneFilter,
    removeOneFilter,
    clearFilter,
    clearAllFilters,
    setIsClearAllClicked,
    setItemToRemove,
  } = useAlgoliaActions();
  const { castNumFilters, templateGroupTypeFilters, isClearAllClicked, itemToRemove } = useSelector(
    (state) => state.AlgoliaSlice,
  );

  return {
    addOneFilter,
    removeOneFilter,
    clearFilter,
    clearAllFilters,
    castNumFilters,
    templateGroupTypeFilters,
    isClearAllClicked,
    setIsClearAllClicked,
    itemToRemove,
    setItemToRemove,
  };
};

export default useAlgolia;
